import React from 'react';
import { Link } from 'react-router-dom';
import kenyaFlag from '../images/kenya-flag.png'

const Navbar = () => {
  return (
    <nav className="bg-kenya-green text-kenya-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold flex items-center">
          <img 
           src={kenyaFlag} 
            alt="Kenya Flag" 
            className="h-8 mr-2"
          />
          Diaspora Petition
        </Link>
        <div className="space-x-4">
          <Link to="/" className="hover:underline">Home</Link>
          <Link to="/gallery" className="hover:underline">Gallery</Link>
          <Link to="/stories" className="hover:underline">Stories</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;